import * as z from 'zod';

import { SftpSiteId } from '../BrandedIds';
import { Sensitive } from '../secrets/Sensitive';

export const SftpSite = z.object({
  id: SftpSiteId,
  name: z.string(),
  hostname: z.string(),
  port: z.number(),
  path: z.string(),
  username: z.string(),
});

export type SftpSite = z.infer<typeof SftpSite>;

export type SftpSiteWithSecrets = SftpSite & {
  password: Sensitive<string> | undefined;
};

// `password` is nullish (not just optional) because GraphQL codegen surfaces
// nullable inputs as `string | null | undefined`.
export const SftpSiteInput = z.object({
  name: z.string(),
  hostname: z.string(),
  port: z.number(),
  path: z.string(),
  username: z.string(),
  password: z.string().nullish(),
});
export type SftpSiteInput = z.infer<typeof SftpSiteInput>;

export const UpdateSftpSiteInput = SftpSiteInput.extend({ id: SftpSiteId });
export type UpdateSftpSiteInput = z.infer<typeof UpdateSftpSiteInput>;
